import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Button, Row, Col, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import AddForm from '../components/AddForm';
import { addGoodReceive } from "../../ducks/services"
import { getGoodReceiveOption } from '../../ducks/actions';
import { useTranslate } from 'Translate';

const _ = require('lodash');
const { Title, Text } = Typography;

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");
  const [editable, setEditable] = useState(true);
  const meta = useSelector((state) => state.inventory.goodReceiveOption);
  const i18n = useTranslate();
      const { t } = i18n;

  useEffect(() => {
    dispatch(getGoodReceiveOption(props.setLoading));
  }, []);

  return (
    <Row gutter={[20, 30]}>
      <Col span={24} style={{ position: "sticky", top: "-30px", backgroundColor: "#f5f5f5", zIndex: 3, padding: "10px" }}>
        <Row justify={'space-between'} align={'middle'}>
          <Col flex='auto'>
            <Title level={3} className='mb-0 mt-0'>{t("New.good_receive")}</Title>
          </Col>
          <Col flex='auto' className='text-right'>
            <Space size={10}>
              {editable && activeTab === "1" && <Button size="large" htmlType='submit' className='green-btn text-white' form="gr-details-form">{t("General.save")}</Button>}
              <Button size="large" htmlType='button' className='red-btn text-white' onClick={() => navigate('/inventory/good-receive')}>{'<'} {t("General.back")}</Button>
            </Space>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <AddForm
          loading={props.loading}
          setLoading={props.setLoading}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          oneTab={true}
          mode={'add'}
          meta={meta}
          addGoodReceive={addGoodReceive}
          navigate={navigate}
          reloadApi={(propId) => navigate(`/inventory/good-receive/${propId}?t=2`)}
          allowedEdit={true}
          editable={editable}
          setEditable={setEditable}
        />
      </Col>
    </Row>
  )
}